import {
    StyleSheet
} from "react-native";
import type {
    LineChartMeasuresConstantType,
    LineChartDynamicStyleType,
    LineChartMeasures
} from "./type";

export const LINE_CHART_LABEL_BASELINE_SHIFT = 0.35;

export const LINE_CHART_STACKED_FADE = 0.35;

export const LINE_CHART_OVERLAY_FADE = 0.5;

export const LINE_CHART_MIN_OPACITY = 0.01;

export const getLineChartMeasures = ({
    shapeConfigs,
    typography,
    borders,
    spaces
}: LineChartMeasuresConstantType): LineChartMeasures => {
    return {
        labelWeight: typography.labelSmallSize.fontWeight,
        dotRadius: shapeConfigs.chartDotSize / 2,
        haloWidth: shapeConfigs.chartHaloWidth,
        typography: typography.bodySmallSize,
        crosshairWidth: borders.line,
        lineWidth: borders.chartLine,
        spacingSm: spaces.spacingSm,
        spacingXs: spaces.spacingXs,
        spacingMd: spaces.spacingMd
    };
};

const stylesheet = StyleSheet.create({
    container: {
        width: "100%"
    }
});

export const useStyles = ({
    colors
}: LineChartDynamicStyleType) => {
    const styles = {
        crosshair: colors.content.border.hover,
        valueLabel: colors.content.text.high,
        nameLabel: colors.content.text.mid
    };

    return styles;
};
export default stylesheet;
